import { useContext } from "react";

import {
	TillAppearanceContext,
	type TillAppearanceContextValue,
} from "@/features/content/content-settings-provider";

export function useTillAppearance(): TillAppearanceContextValue {
	const value = useContext(TillAppearanceContext);
	if (!value) {
		throw new Error(
			"useTillAppearance must be used inside ContentSettingsProvider",
		);
	}
	return value;
}
